import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import WithIframe from '../../../Common/WithIframe/WithIframe';
import { lookerParams } from '../../../../shared/lookerParams';
import { useCompare } from '../../../../shared/hooks';
import LookerService from '../../Analytics/LookerDashboard/lookerService';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as R from 'ramda';

const lookerService = new LookerService();

//#region PropTypes
const propTypes = {
    customerId: PropTypes.number,
};

const defaultProps = {
    customerId: null,
};
//#endregion

const drawerWidth = 315;

const StyledList = styled(List)({
    // selected and (selected + hover) states
    '&& .Mui-selected, && .Mui-selected:hover': {
        backgroundColor: '#166c9d',
        '&, & .MuiListItemIcon-root': {
            color: 'white',
        },
    },
    // hover states
    '& .MuiListItemButton-root:hover': {
        backgroundColor: '#b1c8d4',
        '&, & .MuiListItemIcon-root': {
            color: 'white',
        },
    },
});

const openedMixin = (theme) => ({
    width: drawerWidth,
    top: '12.5%',
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    top: '12.5%',
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} )`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    top: null,
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
    }),
}));

const safeJsonParse = R.tryCatch(JSON.parse, R.always(null));

const TabDashboard = (props) => {
    const [open, setOpen] = React.useState(true);
    const [openVistaContent, setOpenVistaContent] = React.useState(true);
    const [openMyVistaContent, setMyVistaContent] = React.useState(true);
    const [openMyVistaFav, setMyVistaFav] = React.useState(true);
    const [openMyCustomer, setMyCustomer] = React.useState(true);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [selectedIndexFav, setSelectedIndexFav] = React.useState(null);
    const [selectedIndexContent, setSelectedIndexContent] = React.useState(null);
    const [menuSearchText, setMenuSearchText] = React.useState('');

    let fomCustomer = localStorage.getItem('FOM_recent_customer');
    const customerData = safeJsonParse(fomCustomer);

    let fomUser = localStorage.getItem('FOM_user');
    const userData = safeJsonParse(fomUser);

    const cusData = userData && userData.userdata.details.role == 'CUSTOMER' ? userData.userdata.details : customerData;

    const handleDrawerToggel = () => {
        setOpen(!open);
    };

    const handleVistaContentToggel = () => {
        setOpenVistaContent(!openVistaContent);
    };
    const handleMyVistaContentToggel = () => {
        setMyVistaContent(!openMyVistaContent);
    };
    const handleMyVistaFavToggel = () => {
        setMyVistaFav(!openMyVistaFav);
    };

    const handleMyCustomerToggel = () => {
        setMyCustomer(!openMyCustomer);
    };

    const { customerId } = props;

    const [lookerDashboardUrls, setLookerDashboardUrls] = useState([]);
    const [loading, setLoading] = useState(true);
    const [myFavLook, setMyFavLook] = useState(false);
    const [myContentLook, setMyContentLook] = useState(false);
    const [myCustomerLook, setMyCustomerLook] = useState(false);

    const hasCustomerIdChanged = useCompare(customerId);

    const [currentActiveTab, setCurrentActiveTab] = useState('');

    const dashboardLabels = [
        'Dispense - Financial Metrics',
        'Dispense - Prescriber Metrics',
        'EMR - Capture Rate',
        'EMR - Prescriptions Written',
    ];

    const [filterMenu, setFilterMenu] = useState(lookerDashboardUrls);

    const { models, dispenseFinancial, dispensePrescriber, emrCapture, emrPrescriptions } =
        lookerParams.actualsLookerPath;

    // Exact order for dashboards
    const dashboardPaths = [
        dispenseFinancial.dashboard,
        dispensePrescriber.dashboard,
        emrCapture.dashboard,
        emrPrescriptions.dashboard,
    ];

    const menuSearchEvent = (event) => {
        let text = '';

        if (event && event.target) {
            text = event.target.value;
            setMenuSearchText(event.target.value);
            setFilterMenu(lookerDashboardUrls.filter((x) => x.title.toLowerCase().includes(text.toLowerCase())));
        }
        if (text && text.length == 0) {
            setFilterMenu(lookerDashboardUrls);
        }
    };

    // Handles Tab changes and ensures embed content is loaded when tab is clicked
    const tabChangeHandler = useCallback(
        async (selectedTabKey) => {
            if (lookerDashboardUrls?.length) {
                const loadedDashboardUrls = await Promise.all(
                    lookerDashboardUrls.map(async (dashboardUrl) => {
                        const { key, loaded, tabKey } = dashboardUrl;
                        if (tabKey === selectedTabKey && !loaded) {
                            const lookerServiceGetDashboardData = {
                                lookerModel: models,
                                // Send only the current dashboardUrl.key property to fetch only that Url
                                lookerPaths: [key],
                                currentCustomerId: customerId,
                            };

                            // Always fetch a new url for unloaded dashboards
                            const {
                                data: { lookerDashboardEmbeddedUrls },
                            } = await lookerService.getLookerDashboardEmbeddedUrls(lookerServiceGetDashboardData);
                            const [currentDashboardUrl] = lookerDashboardEmbeddedUrls;
                            return {
                                ...dashboardUrl,
                                url: currentDashboardUrl,
                                loaded: true,
                            };
                        }
                        return dashboardUrl;
                    }),
                );
                setLookerDashboardUrls(loadedDashboardUrls);
            }
            setCurrentActiveTab(selectedTabKey);
        },
        [lookerDashboardUrls, customerId, models],
    );

    const getEmbedUrls = useCallback(async () => {
        // Extract the first url as the default value
        const [defaultDashboardPathKey] = dashboardPaths;

        const data = {
            lookerModel: models,
            lookerPaths: dashboardPaths,
            currentCustomerId: customerId,
        };

        try {
            // Only get Dashboard Urls if there are none and if role is ADMIN
            const res = await lookerService.getLookerDashboardEmbeddedUrls(data);

            if (res && res.data) {
                console.log('getLookerDashboardEmbeddedUrls :', res);
                const {
                    lookerDashboardEmbeddedUrls,
                    result: { myContent, myFavorite, myCustomer },
                } = res.data;

                const dashboardUrls = dashboardPaths.map((dashboardPath, index) => ({
                    title: dashboardLabels[index],
                    url: lookerDashboardEmbeddedUrls && lookerDashboardEmbeddedUrls[index],
                    key: dashboardPath,
                    // Load default Dashboard Url
                    loaded: defaultDashboardPathKey === dashboardPath,
                    menu: 'vistaMenu',
                    tabKey: dashboardPath + 'vistaMenu',
                }));

                setLookerDashboardUrls([...dashboardUrls, ...myContent, ...myFavorite, ...myCustomer]);

                myContent.map((mc) => {
                    if (mc.name == 'Looks') {
                        setMyContentLook(true);
                    }
                });

                myFavorite.map((mf) => {
                    if (mf.name == 'Looks') {
                        setMyFavLook(true);
                    }
                });

                myCustomer.map((mf) => {
                    if (mf.name == 'Looks') {
                        setMyCustomerLook(true);
                    }
                });

                setCurrentActiveTab(defaultDashboardPathKey + 'vistaMenu');
                setLoading(false);
                setFilterMenu([...dashboardUrls, ...myContent, ...myFavorite, ...myCustomer]);
            } else {
                console.log('getLookerDashboardEmbeddedUrls Error:', res);
            }
        } catch (error) {
            console.error(error);
        }
    }, [customerId, dashboardLabels, dashboardPaths, models]);

    useEffect(() => {
        if (customerId && hasCustomerIdChanged) {
            setLoading(true);
            // Set to empty array so iframe unloads from DOM
            setLookerDashboardUrls([]);
            getEmbedUrls();
        }
    }, [customerId, hasCustomerIdChanged, getEmbedUrls]);

    return (
        <Box sx={{ display: 'flex' }}>
            <Drawer sx={{ zIndex: 0, height: 44 }} variant="permanent" open={open}>
                <DrawerHeader>
                    {open === true ? (
                        <>
                            {' '}
                            <Form.Control
                                className="menu-search"
                                type="text"
                                placeholder="Search"
                                autoComplete="none"
                                onChange={(e) => {
                                    menuSearchEvent(e);
                                }}
                                value={menuSearchText}
                            />
                            <FontAwesomeIcon icon={faSearch} className="menu-search-icon" />
                        </>
                    ) : null}
                    <IconButton onClick={handleDrawerToggel}>
                        {!open ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </DrawerHeader>
                <Divider />

                {open === true ? (
                    <div className="sideMenu-coll">
                        <StyledList>
                            <ListItemButton onClick={handleMyVistaFavToggel}>
                                {openMyVistaFav ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                                <ListItemText
                                    primary="Favorites"
                                    sx={{ fontWeight: 'bold', color: '#166c9d' }}
                                    disableTypography
                                />
                            </ListItemButton>
                            <Collapse in={openMyVistaFav} timeout="auto" unmountOnExit>
                                {filterMenu.length > 0 &&
                                    filterMenu.map((favorite, index) =>
                                        favorite.menu == 'myFavorite' && favorite.name == 'Dashboard' ? (
                                            <ListItem
                                                key={favorite.title}
                                                disablePadding
                                                sx={{ display: 'block', width: 315 }}
                                            >
                                                <ListItemButton
                                                    selected={selectedIndexFav === index}
                                                    key={favorite.tabKey}
                                                    eventKey={favorite.tabKey}
                                                    sx={{
                                                        minHeight: 48,
                                                        justifyContent: open ? 'initial' : 'center',
                                                        px: 2.5,
                                                    }}
                                                    onClick={() => {
                                                        tabChangeHandler(favorite.tabKey);
                                                        setSelectedIndexFav(index);
                                                        setSelectedIndex(null);
                                                        setSelectedIndexContent(null);
                                                    }}
                                                >
                                                    <ListItemText
                                                        primary={favorite.title}
                                                        sx={{ opacity: open ? 1 : 0, paddingLeft: 3 }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        ) : null,
                                    )}
                                {myFavLook && <label className="looks-lable"> Looks </label>}
                                {filterMenu.length > 0 &&
                                    filterMenu.map((favorite, index) =>
                                        favorite.menu == 'myFavorite' && favorite.name == 'Looks' ? (
                                            <ListItem
                                                key={favorite.title}
                                                disablePadding
                                                sx={{ display: 'block', width: 315 }}
                                            >
                                                <ListItemButton
                                                    selected={selectedIndexFav === index}
                                                    key={favorite.tabKey}
                                                    eventKey={favorite.tabKey}
                                                    sx={{
                                                        minHeight: 48,
                                                        justifyContent: open ? 'initial' : 'center',
                                                        px: 2.5,
                                                    }}
                                                    onClick={() => {
                                                        tabChangeHandler(favorite.tabKey);
                                                        setSelectedIndexFav(index);
                                                        setSelectedIndex(null);
                                                        setSelectedIndexContent(null);
                                                    }}
                                                >
                                                    <ListItemText
                                                        primary={favorite.title}
                                                        sx={{ opacity: open ? 1 : 0, paddingLeft: 3 }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        ) : null,
                                    )}
                            </Collapse>
                        </StyledList>

                        <StyledList>
                            <ListItemButton onClick={handleVistaContentToggel}>
                                {openVistaContent ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                                <ListItemText
                                    primary="TherigyVista Content"
                                    sx={{ fontWeight: 'bold', color: '#166c9d' }}
                                    disableTypography
                                />
                            </ListItemButton>
                            <Collapse in={openVistaContent} timeout="auto" unmountOnExit>
                                {filterMenu.length > 0 &&
                                    filterMenu.map((dashboardUrl, index) =>
                                        dashboardUrl.menu == 'vistaMenu' ? (
                                            <ListItem
                                                key={dashboardUrl.title}
                                                disablePadding
                                                sx={{ display: 'block', width: 315 }}
                                            >
                                                <ListItemButton
                                                    selected={selectedIndex === index}
                                                    key={dashboardUrl.tabKey}
                                                    eventKey={dashboardUrl.tabKey}
                                                    sx={{
                                                        minHeight: 48,
                                                        justifyContent: open ? 'initial' : 'center',
                                                        px: 2.5,
                                                    }}
                                                    onClick={() => {
                                                        tabChangeHandler(dashboardUrl.tabKey);
                                                        setSelectedIndex(index);
                                                        setSelectedIndexContent(null);
                                                        setSelectedIndexFav(null);
                                                    }}
                                                >
                                                    <ListItemText
                                                        primary={dashboardUrl.title}
                                                        sx={{ opacity: open ? 1 : 0, paddingLeft: 3 }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        ) : null,
                                    )}
                            </Collapse>
                        </StyledList>
                        {cusData && (
                            <StyledList>
                                <ListItemButton onClick={handleMyCustomerToggel}>
                                    {openMyCustomer ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                                    <ListItemText
                                        primary={cusData.customerName + "'s Content"}
                                        sx={{ fontWeight: 'bold', color: '#166c9d' }}
                                        disableTypography
                                    />
                                </ListItemButton>
                                <Collapse in={openMyCustomer} timeout="auto" unmountOnExit>
                                    {filterMenu.length > 0 &&
                                        filterMenu.map((myCustomer, index) =>
                                            myCustomer.menu == 'myCustomer' && myCustomer.name == 'Dashboard' ? (
                                                <ListItem
                                                    key={myCustomer.title}
                                                    disablePadding
                                                    sx={{ display: 'block', width: 315 }}
                                                >
                                                    <ListItemButton
                                                        selected={selectedIndexContent === index}
                                                        key={myCustomer.tabKey}
                                                        eventKey={myCustomer.tabKey}
                                                        sx={{
                                                            minHeight: 48,
                                                            justifyContent: open ? 'initial' : 'center',
                                                            px: 2.5,
                                                        }}
                                                        onClick={() => {
                                                            tabChangeHandler(myCustomer.tabKey);
                                                            setSelectedIndexContent(index);
                                                            setSelectedIndex(null);
                                                            setSelectedIndexFav(null);
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary={myCustomer.title}
                                                            sx={{ opacity: open ? 1 : 0, paddingLeft: 3 }}
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                            ) : null,
                                        )}
                                    {myCustomerLook && <label className="looks-lable"> Looks </label>}
                                    {filterMenu.length > 0 &&
                                        filterMenu.map((myCustomer, index) =>
                                            myCustomer.menu == 'myCustomer' && myCustomer.name == 'Looks' ? (
                                                <ListItem
                                                    key={myCustomer.title}
                                                    disablePadding
                                                    sx={{ display: 'block', width: 315 }}
                                                >
                                                    <ListItemButton
                                                        selected={selectedIndexContent === index}
                                                        key={myCustomer.tabKey}
                                                        eventKey={myCustomer.tabKey}
                                                        sx={{
                                                            minHeight: 48,
                                                            justifyContent: open ? 'initial' : 'center',
                                                            px: 2.5,
                                                        }}
                                                        onClick={() => {
                                                            tabChangeHandler(myCustomer.tabKey);
                                                            setSelectedIndexContent(index);
                                                            setSelectedIndex(null);
                                                            setSelectedIndexFav(null);
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary={myCustomer.title}
                                                            sx={{ opacity: open ? 1 : 0, paddingLeft: 3 }}
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                            ) : null,
                                        )}
                                </Collapse>
                            </StyledList>
                        )}
                        <StyledList>
                            <ListItemButton onClick={handleMyVistaContentToggel}>
                                {openMyVistaContent ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                                <ListItemText
                                    primary="My Content"
                                    sx={{ fontWeight: 'bold', color: '#166c9d' }}
                                    disableTypography
                                />
                            </ListItemButton>
                            <Collapse in={openMyVistaContent} timeout="auto" unmountOnExit>
                                {filterMenu.length > 0 &&
                                    filterMenu.map((myContent, index) =>
                                        myContent.menu == 'myContent' && myContent.name == 'Dashboard' ? (
                                            <ListItem
                                                key={myContent.title}
                                                disablePadding
                                                sx={{ display: 'block', width: 315 }}
                                            >
                                                <ListItemButton
                                                    selected={selectedIndexContent === index}
                                                    key={myContent.tabKey}
                                                    eventKey={myContent.tabKey}
                                                    sx={{
                                                        minHeight: 48,
                                                        justifyContent: open ? 'initial' : 'center',
                                                        px: 2.5,
                                                    }}
                                                    onClick={() => {
                                                        tabChangeHandler(myContent.tabKey);
                                                        setSelectedIndexContent(index);
                                                        setSelectedIndex(null);
                                                        setSelectedIndexFav(null);
                                                    }}
                                                >
                                                    <ListItemText
                                                        primary={myContent.title}
                                                        sx={{ opacity: open ? 1 : 0, paddingLeft: 3 }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        ) : null,
                                    )}
                                {myContentLook && <label className="looks-lable"> Looks </label>}
                                {filterMenu.length > 0 &&
                                    filterMenu.map((myContent, index) =>
                                        myContent.menu == 'myContent' && myContent.name == 'Looks' ? (
                                            <ListItem
                                                key={myContent.title}
                                                disablePadding
                                                sx={{ display: 'block', width: 315 }}
                                            >
                                                <ListItemButton
                                                    selected={selectedIndexContent === index}
                                                    key={myContent.tabKey}
                                                    eventKey={myContent.tabKey}
                                                    sx={{
                                                        minHeight: 48,
                                                        justifyContent: open ? 'initial' : 'center',
                                                        px: 2.5,
                                                    }}
                                                    onClick={() => {
                                                        tabChangeHandler(myContent.tabKey);
                                                        setSelectedIndexContent(index);
                                                        setSelectedIndex(null);
                                                        setSelectedIndexFav(null);
                                                    }}
                                                >
                                                    <ListItemText
                                                        primary={myContent.title}
                                                        sx={{ opacity: open ? 1 : 0, paddingLeft: 3 }}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        ) : null,
                                    )}
                            </Collapse>
                        </StyledList>
                    </div>
                ) : null}
            </Drawer>

            <Box component="main" sx={{ flexGrow: 1, p: 3, padding: 1 }}>
                <Tabs activeKey={currentActiveTab} className="pt-2 pl-3 bg-white">
                    {!loading &&
                        lookerDashboardUrls.length &&
                        lookerDashboardUrls.map((dashboardUrl) => (
                            <Tab key={dashboardUrl.tabKey} eventKey={dashboardUrl.tabKey}>
                                {dashboardUrl?.loaded ? (
                                    <WithIframe url={dashboardUrl.url} key={dashboardUrl.key} />
                                ) : null}
                            </Tab>
                        ))}
                </Tabs>
            </Box>
        </Box>
    );
};

TabDashboard.propTypes = propTypes;
TabDashboard.defaultProps = defaultProps;

export default TabDashboard;
